import React from 'react';
import * as T from './types';
import * as S from './styles';
import "./colorgenstyles.css";
import { HexColorPicker, HexColorInput } from "react-colorful";
import { debounce } from 'lodash';

const ColorGenerator: React.FC<T.IProps> = (props) => {

  const [firstChange, setFirstChange] = React.useState(false);
  const [colorSelected, setColorSelected] = React.useState<string>();

  const onColorChange = (color: string) => props.onChange(color);

  const debounceFunction = React.useCallback(
    debounce((color: string) => {
      setColorSelected(color);
      setFirstChange(true);
    }, 400), []
  );

  React.useEffect(() => {
    debounceFunction(props.color);
  }, [props.color]);

  React.useEffect(() => {
    if (firstChange && colorSelected && props.onFinishChange) props.onFinishChange();
  }, [colorSelected]);

  return (
    <section className="colorgen" >
      {
        props.show &&
        <S.Root style={props.style} >
          <HexColorPicker color={props.color} onChange={onColorChange} style={props.paletteStyle} />
          <S.Bottom>
            {props.showInputText &&
              <HexColorInput
                type="text"
                color={props.color}
                onChange={onColorChange}
                onBlur={() => props.onFinishChange ? props.onFinishChange() : () => { }}
                prefixed={true}
                style={{
                  ...props.textStyle,
                  width: '100%',
                  boxSizing: 'border-box',
                  borderRadius: '2px',
                  margin: '0px',
                }}
              />
            }
          </S.Bottom>
        </S.Root>
      }
    </section>
  );
}

export default ColorGenerator;